import numeral from 'numeral';

export function formatNumber(value: number) {
  return numeral(value).format('0,00');
}

export function formatCurrency(value: number) {
  return numeral(value).format('$0,0');
}